// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3yXu0","loading":"styles_loading__25018"};